<template>
  <v-dialog v-model="open" max-width="900px" persistent scrollable>
    <template v-slot:activator="{ on, attrs }">
      <location-info-item
          icon="mdi-calendar"
          icon-action="mdi-pencil-outline"
          title="Horários especiais"
          v-bind="attrs"
          v-on="on"
      >
        <template slot:subtitle>
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
              <tr v-for="(specialHours, date) in originalData" :key="date">
                <td class="td-day">{{ parseDate(date) }}</td>
                <td v-for="(time, index) in specialHours" :key="index">
                  <span>{{ getResumeItemLabel(time) }}</span>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </template>
      </location-info-item>
    </template>

    <v-card>
      <v-toolbar elevation="0">
        <v-card-title class="ml-0 pl-1">
          Horários especiais
        </v-card-title>

        <v-spacer />

        <v-btn icon @click="open = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-form
            @submit="e => e.preventDefault()"
            ref="form"
            v-model="formValid"
            lazy-validation
        >
          <location-special-schedule-list
              v-bind:value="formData.special_hours"
              v-on:change="updateData"
              :limit="10"
              add-text="Adicionar horário"
          />

          <v-alert
            v-if="alertScheduledTask"
            dense
            border="right"
            type="warning"
          >
            Existe um agendamento pendente para essa informação
          </v-alert>

          <schedule-form  v-if="!bulkUpdate" v-on:change="changeScheduleDate" />
        </v-form>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="secondary"
            text
            @click="cancel"
        >
          Cancelar
        </v-btn>
        <v-btn
            :loading="loading"
            color="primary"
            text
            @click="callAction"
        >
          Aplicar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapState} from 'vuex'
import {TYPE_UPDATE_LOCATION_SPECIAL_HOUR} from '@/constants/tasks'
import ScheduleForm from '@/views/Locations/Components/ScheduleForm'
import LocationSpecialScheduleList from '@/views/Locations/Components/LocationSpecialScheduleList'
import LocationInfoItem from '@/views/Locations/Components/LocationInfoItem'
import {get} from 'lodash'

export default {
  name: "LocationSpecialScheduleModal",
  props: {
    action: Function,
    bulkUpdate: {
      type: Boolean
    },
    alertScheduleTask: Array,
  },
  components: {
    LocationInfoItem,
    ScheduleForm,
    LocationSpecialScheduleList
  },
  computed: {
    ...mapState({
      location: state => state.locations.location
    })
  },
  beforeDestroy() {
    this.resetData()
  },
  mounted() {
    if (this.location && !this.bulkUpdate) {
      this.formData.special_hours = get(this.location, 'data.specialHours', {})
      this.originalData = (this.location.data.specialHours) ?? []

      this.setData(this.location)
    }

    if(this.alertScheduleTask) {
      this.alertScheduleTask.map(type => {
        if(type === TYPE_UPDATE_LOCATION_SPECIAL_HOUR) {
          this.alertScheduledTask = true;
        }
      })
    }
  },
  data: () => ({
    open: false,
    loading: false,
    formValid: true,
    value: {},
    formDataOriginal: {},
    formData: {
      schedule_type: TYPE_UPDATE_LOCATION_SPECIAL_HOUR,
      special_hours: {},
      schedule_start: '',
      schedule_start_at: '',
      schedule_end: '',
      schedule_end_at: '',
    },
    alertScheduledTask: null,
    originalData: []
  }),
  methods: {
    parseData(value) {
      let newData = []
      if (value) {
        const data = JSON.parse(JSON.stringify(value)) // Cria uma cópia do objeto
        if (data) {
          for (const d in data) {
            newData.push(data[d])
          }
        }
      }
      return newData
    },
    cancel() {
      this.open = false
      this.resetData()
    },
    resetData() {
      const {special_hours} = this.formDataOriginal
      this.formData.special_hours = special_hours
      this.value = {}
      if (this.bulkUpdate) {
        this.$emit('removePayload', 'special_hours')
      }
    },
    callAction: async function () {
      if (this.$refs.form.validate()) {
        this.loading = true

        let data = { ...this.formData }
        let specialHours = this.formData.special_hours
        let newPayload = []
        for(const d in specialHours) {
          for(const key in specialHours[d]) {
            newPayload.push(specialHours[d][key])
          }
        }

        data.special_hours = newPayload

        if (this.bulkUpdate) {
          this.$emit('savePayload', 'special_hours', data.special_hours);
        } else if (this.action) {
          await this.action(data)
        }

        this.open = false
        this.loading = false
      }
    },
    validate() {
      return this.$refs.form.validate()
    },
    changeScheduleDate(data) {
      this.formData.schedule_start = data.schedule_start
      this.formData.schedule_start_at = data.schedule_start_at
      this.formData.schedule_end = data.schedule_end
      this.formData.schedule_end_at = data.schedule_end_at
    },
    updateData(values) {
      this.formData.special_hours = values
    },
    getResumeItemLabel(time) {
      if (time.is_24_hours) {
        return '24 horas'
      }
      if (time.is_closed) {
        return 'Fechado'
      }
      return `${time.open_time} - ${time.close_time}`
    },
    setData(location) {
      this.formData.special_hours = this.parseData(get(location, 'data.specialHours', [])).sort((a, b) => {
        if (a.start_date > b.start_date) return 1
        if (a.start_date < b.start_date) return -1
        return 0
      })
      this.formDataOriginal.special_hours = this.parseData(get(location, 'data.specialHours', [])).sort((a, b) => {
        if (a.start_date > b.start_date) return 1
        if (a.start_date < b.start_date) return -1
        return 0
      })
    },
    parseDate(date) {
      if (date && typeof date === 'string') {
        const split = date.split('-')
        return `${split[2]}/${split[1]}/${split[0]}`
      }
    }
  },
  watch: {
    location(location) {
      if (!this.bulkUpdate) {
        this.formData.special_hours = get(location, 'data.specialHours', {})
        this.originalData = (this.formData.special_hours) ?? []

        this.setData(location)
      }
    },
    open(open) {
      if (open && !this.bulkUpdate) {
        this.setData(this.location)
      }
    }
  }
}
</script>

<style scoped>
::v-deep td {
  border: none !important;
  padding-left: 0 !important;
  color: rgba(0, 0, 0, 0.6) !important;
}

::v-deep td.td-day {
  width: 110px;
}

::v-deep tr:hover {
  background-color: transparent !important;
}
</style>